import { render } from "./cookiesPolicy.vue?vue&type=template&id=fbde7a4e&scoped=true&lang=html"
import script from "./cookiesPolicy.vue?vue&type=script&lang=js"
export * from "./cookiesPolicy.vue?vue&type=script&lang=js"

import "./cookiesPolicy.vue?vue&type=style&index=0&id=fbde7a4e&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbde7a4e"]])

export default __exports__